import {Grid} from '@material-ui/core';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core/styles/index";
import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Route} from 'react-router';
import {Redirect, Switch, withRouter} from 'react-router-dom';
import {redirectLoginDone} from '../../../reducers/authReducer';
import Notification from '../../common/App/Notification';
import Error403 from '../../common/ErrorsPages/Error403';
import Error404 from '../../common/ErrorsPages/Error404';
import {classesNames} from '../../common/Tools/Tools';
import AppAdminCss from "./css/AppAdminCss";
import {theme} from './css/theme';
import LeftMenu from "./LeftMenu";
import {routes} from './routes/routes';
import TopBar from './TopBar';
import {watchGpsLocalisation} from '../Mobilier/actions/gpsActions'

class AppAdmin extends Component {
  state = {
    goToLogin: false,
    leftMenuOpen: window.innerWidth > 1600,
    watch_gps_id:null
  };

  componentDidMount(){
    /* eslint-disable-next-line */
    this.state.watch_gps_id = watchGpsLocalisation(this.props.dispatch)
  }
  
  componentWillUnmount(){
    if(navigator.geolocation){
      navigator.geolocation.clearWatch(this.state.watch_gps_id)
    }
  }

  /**
   * Retourne le nouveau state en fonction des nextProps
   * @param  {[type]} nextProps [description]
   * @param  {[type]} prevState [description]
   * @return {[type]}           [description]
   */
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.goToLogin) {
      if (nextProps.location.pathname !== "/auth") nextProps.history.push("/auth");
      redirectLoginDone(nextProps.dispatch)
    }

    return null;
  }

  handleLeftMenuToggle() {
    this.setState({leftMenuOpen: !this.state.leftMenuOpen});
  }


  /**
   * Gestion de la redirection sur le login pour les utilisateurs non authentifiés
   * @param r
   * @param props
   * @returns {*}
   */
  renderComponent(r, props) {
    const {user} = this.props;

    if (r.public || (!!user && user.rights.indexOf(r.right) > -1)) return <r.component {...props} />;
    else if (!!user && user.rights.indexOf(r.right) === -1) return <Error403/>;
    else return <Redirect to="/auth"/>;
  }

  getContent() {
    const {classes, currentRouteConfig} = this.props;

    let switchComponent = <Switch>
      {routes.map(r => <Route path={r.path} exact={r.exact} key={r.path} render={this.renderComponent.bind(this, r)}/>)}
      <Route component={Error404}/>
    </Switch>;


    if (currentRouteConfig.noContainer) {
      return (
        <div className={classes.root}>
          {switchComponent}
          <Notification/>
        </div>
      );
    }
    else

      return (
        <main
          className={this.state.leftMenuOpen ? classes.content : classes.content + ' ' + classes.contentCollapsedLeftMargin}
        >
          <div className={classes.toolbar}/>
          <Grid
            container
            className={classes.root}
            style={{padding: theme.spacing(3)}}
          >
            {switchComponent}
          </Grid>
          <Notification/>
        </main>
      );
  }

  /**
   * Fonction de rendu final du composant
   */
  render() {
    const {classes, currentRouteConfig} = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <div className={classesNames({[classes.root]: true, [classes.height100]: currentRouteConfig.noContainer})}>
          <TopBar leftMenuOpen={this.state.leftMenuOpen}
                  handleLeftMenuToggle={this.handleLeftMenuToggle.bind(this)}
                  noContainer={currentRouteConfig.noContainer}
          />
          <LeftMenu open={this.state.leftMenuOpen}
                    handleLeftMenuToggle={this.handleLeftMenuToggle.bind(this)}
                    noContainer={currentRouteConfig.noContainer}
          />
          {this.getContent()}
        </div>
      </MuiThemeProvider>
    );
  }
}

AppAdmin = connect((store) => {
  return {
    goToLogin: store.auth.goToLogin,
    location: store.router.location,
    user: store.auth.user,
    currentRouteConfig: store.app.currentRouteConfig
  }
})(AppAdmin);

AppAdmin = withStyles(AppAdminCss)(AppAdmin);
AppAdmin = withRouter(AppAdmin);

export default AppAdmin
